import React, { useEffect, useState } from "react";
import Header from "../master/SideBar.jsx";
import Nav from "../master/NavBar.jsx";
import Footer from "../main/footer";
import { getRteStudent } from "../../api/RteService";
import { getSessions } from "../../api/SessionsService";
import { courseList } from "../../api/Courses.js";
import { useNavigate } from "react-router-dom";
import DownloadExcel from "../master/DownloadExcel";
import { updataRTE, getBusinessDetails } from "../../api/userService.js";
import Swal from "sweetalert2";
import { formatDate } from "../master/Master.jsx";
import StudentHeader from "../students/v2/StudentHeader.jsx";

export default function Rte() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [sessions, setSession] = useState([]);
  const [courses, setCourse] = useState([]);

  const [search, setSearch] = useState("");
  const [sessionId, setSessionId] = useState("all");
  const [courseId, setCourseId] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const handleSession = async () => {
    const res = await getSessions();
    if (res?.data?.status) {
      setSession(res.data.data);
    }
  };
  const handleCourse = async () => {
    const res = await courseList();
    if (res?.data?.status) {
      setCourse(res.data.data);
    }
  };
  const handleFilter = async () => {
    let addUrl = `&name=${search}&session=${sessionId}&course=${courseId}&page=${page}`;
    const res = await getRteStudent(addUrl);
    if (res?.data?.status) {
      setStudents(res.data.data);
    }
  };

  useEffect(() => {
    handleFilter();
    handleSession();
    handleCourse();
  }, [page]);

  const handleDownload = () => {
    const exportData = students?.data?.data || []; // ✅ Get array of students
    if (exportData.length === 0) {
      alert("No data available to export");
      return;
    }

    // ✅ Transform API data into Excel-friendly format
    const formattedData = exportData.map((student, index) => ({
      SN: index + 1,
      "Student Name": student.name || "",
      "Father Name": student.father_name || "",
      mobile: student.phone || "",
      district: student.district || "",
      village: student.village || "",
      pincode: student.zipcode || "",
      state: student.state || "",
      followup_date: formatDate(student.fee_info?.followup_date) || "",
    }));

    // ✅ Pass formatted data to your download function
    DownloadExcel(
      formattedData,
      [
        "SN",
        "Student Name",
        "Father Name",
        "mobile",
        "district",
        "village",
        "pincode",
        "state",
        "followup_date",
      ],
      "Enquiry List"
    );
  };

  const [businessDetails, setBusinessDetails] = useState({});

  let activeToasts = [];

  function showCustomToast(message, type = "error") {
    const toast = document.createElement("div");
    toast.className = `custom-toast ${type}`;
    toast.innerText = message;

    // Calculate offset from bottom
    const gap = 10; // gap between toasts
    const toastHeight = 70; // estimated height
    const index = activeToasts.length;

    toast.style.bottom = `${1 + index * (toastHeight + gap)}px`;

    document.body.appendChild(toast);
    activeToasts.push(toast);

    // Animate in
    setTimeout(() => {
      toast.classList.add("show");
    }, 10); // short delay for CSS transition

    // Auto remove
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => {
        toast.remove();
        activeToasts = activeToasts.filter((t) => t !== toast);
        repositionToasts(); // adjust remaining toasts
      }, 300);
    }, 4000);
  }

  // Shift remaining toasts upward when one is removed
  function repositionToasts() {
    const gap = 3;
    const toastHeight = 10;

    activeToasts.forEach((toast, index) => {
      toast.style.bottom = `${1 + index * (toastHeight + gap)}px`;
    });
  }

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const fetchBusinessDetails = async () => {
    setLoading(true);
    try {
      const response = await getBusinessDetails();
      if (response.data.status) {
        setBusinessDetails(response.data.data.settings);
        // setProfileImg(response?.data?.data);
        // console.log("Business Details:", response.data.data.settings); // For debugging
        setError("");
        return response.data.data.settings;
      } else {
        setError(response.data.message || "Failed to fetch business details.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to load business details"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBusinessDetails();
  }, []);

  const updataRte = async (e) => {
    e.preventDefault();

    try {
      const form = e.target;
      const rteValues = [];

      // ✅ Collect all checked checkbox values
      form.querySelectorAll('input[name="rte"]:checked').forEach((checkbox) => {
        rteValues.push(checkbox.value);
      });

      // ✅ Append each value as 'rte[]' — Laravel will treat it as array
      const formData = new FormData();
      rteValues.forEach((val) => formData.append("rte[]", val));

      // Debug
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      // ✅ POST to API
      const response = await updataRTE(formData);

      if (response.data.status) {
        Toast.fire({
          icon: "success",
          title: "updated successfully!",
        });
      } else {
        Toast.fire("Failed", response.data.message, "error");
      }
    } catch (error) {
      console.error("RTE Update Error:", error.response?.data || error.message);
      const errors = error?.response?.data?.errors;

      if (errors) {
        Object.entries(errors).forEach(([field, messages]) => {
          messages.forEach((msg) => {
            showCustomToast(`${field}: ${msg}`, "error");
          });
        });
      } else {
        const message =
          error?.response?.data?.message ||
          error?.response?.message ||
          error.message ||
          "Something went wrong. Please try again.";
        showCustomToast(message, "error");
      }
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid mt-2">
              <div className="row custom-scroll-layout">
                <div className="col-md-2 left-pane">
                  <StudentHeader data={"Student Portal"} />
                </div>
                <div className="col-md-10 right-pane">
                  <div className="card p-4 mb-4 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                      <h3 className="text-primary fw-bold mb-0">
                        RTE Student List
                      </h3>
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-success btn-sm"
                          onClick={handleDownload}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Export Excel"
                        >
                          <i className="bi bi-cloud-arrow-down ri-20px"></i>
                        </button>

                        {/* 
                      <button
                        className="btn btn-label-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#rteModal"
                        title="RTE Setting"
                      >
                        <i className="bi bi-gear ri-20px"></i>
                      </button> */}
                      </div>
                    </div>

                    {/* Filter Form */}
                    <div className=" rounded-4 p-3 mb-3">
                      <strong className="fs-5">Filter List:</strong>
                      <div className="row">
                        <div className="col-md-3 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Name/Mobile/Reg. No"
                          />
                        </div>
                        <div className="col-md-3 mb-3">
                          <select
                            name="session"
                            value={sessionId}
                            onChange={(e) => setSessionId(e.target.value)}
                            className="form-select"
                          >
                            <option value="all">All Session</option>
                            {sessions.map((item) => (
                              <option
                                selected={item.status == "1" && true}
                                key={item.id}
                                value={item.id}
                              >
                                {item.session}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3 mb-3">
                          <select
                            name="course"
                            value={courseId}
                            onChange={(e) => setCourseId(e.target.value)}
                            className="form-select"
                          >
                            <option value="">Filter by Courses</option>

                            {courses.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3 d-flex justify-content-start gap-2 mb-6">
                          <button
                            className="btn btn-label-primary me-1"
                            onClick={handleFilter}
                          >
                            <i className="ri-arrow-right-line ri-20px" />
                          </button>
                          <a href="?" className="btn btn-label-danger me-1">
                            <i className="ri-restart-line ri-20px" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Students Table */}
                  <div className="card p-3">
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Father's Name</th>
                            <th>Mobile</th>
                            <th>Address</th>
                            <th>Admission Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody className="text-capitalize">
                          {students?.data?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="7"
                                className="text-center text-danger"
                              >
                                No students found
                              </td>
                            </tr>
                          ) : (
                            students?.data?.map((s, i) => (
                              <tr
                                onClick={() =>
                                  navigate(`/student/details?id=${s.id}`)
                                }
                                key={s.id}
                              >
                                <td>{i + 1}</td>
                                <td className="text-primary fw-semibold">
                                  {s.name} ({s.registration_no})
                                </td>
                                <td>{s.father_name}</td>
                                <td>{s.phone}</td>
                                <td>{s.village}</td>
                                <td> {formatDate(s.admission_date)}</td>
                                <td>
                                  <span className="btn btn-label-primary btn-sm py-0 px-1 me-1">
                                    {s.fee_info.rte}
                                  </span>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>

                      {students?.links?.length > 0 && (
                        <nav aria-label="Page navigation " className="mt-10">
                          <p>
                            Showing {students?.from} to {students?.to} of{" "}
                            {students?.total} entries
                          </p>
                          <ul className="pagination pagination-sm">
                            {students?.links?.map((btn, i) => (
                              <li
                                key={i}
                                className={`page-item ${
                                  btn.active ? "active" : ""
                                } ${!btn.url ? "disabled" : ""}`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => {
                                    if (btn.url) {
                                      const url = new URL(btn.url);
                                      const pageParam =
                                        url.searchParams.get("page");
                                      setPage(parseInt(pageParam));
                                    }
                                  }}
                                >
                                  {btn.label === "&laquo; Previous"
                                    ? "«"
                                    : btn.label === "Next &raquo;"
                                    ? "»"
                                    : btn.label}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </nav>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="rteModal"
        tabIndex="-1"
        aria-labelledby="rteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="rteModalLabel">
                RTE Setting
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={updataRte}>
                <div className="p-3 rounded">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rte_course"
                      name="rte"
                      value="course_free"
                      defaultChecked={businessDetails?.rte?.includes(
                        "course_free"
                      )}
                    />
                    <label htmlFor="rte_course" className="form-check-label">
                      Course Fees Free
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rte_bus"
                      name="rte"
                      value="bus_free"
                      defaultChecked={businessDetails?.rte?.includes(
                        "bus_free"
                      )}
                    />
                    <label htmlFor="rte_bus" className="form-check-label">
                      Bus Free
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rte_registration"
                      name="rte"
                      value="registration_free"
                      defaultChecked={businessDetails?.rte?.includes(
                        "registration_free"
                      )}
                    />
                    <label
                      htmlFor="rte_registration"
                      className="form-check-label"
                    >
                      Registration Fees Free
                    </label>
                  </div>

                  <div className="text-end mt-3">
                    <input
                      type="submit"
                      className="btn btn-primary"
                      value="Update RTE"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
